import React, { useEffect, useRef } from 'react';
export function Hero() {
  const headlineRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = headlineRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    const timer = setTimeout(() => {
      el.style.transition = 'opacity 1s ease, transform 1s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 200);
    return () => clearTimeout(timer);
  }, []);
  return <section className="relative w-full overflow-hidden" style={{
    minHeight: '100vh',
    backgroundColor: '#0a0a0a'
  }} aria-label="Hero" data-id="element-187">
      {/* Background image — full bleed on all screen sizes */}
      <div className="absolute inset-0 bg-cover bg-no-repeat" style={{
      backgroundImage: `url(https://cdn.magicpatterns.com/uploads/opVPTQCbnW7CJJSLheCJpn/banner1.png)`,
      backgroundPosition: '70% top'
    }} aria-hidden="true" data-id="element-188" />
      <div className="absolute inset-0 bg-cover bg-no-repeat hidden sm:block" style={{
      backgroundImage: `url(https://cdn.magicpatterns.com/uploads/opVPTQCbnW7CJJSLheCJpn/banner1.png)`,
      backgroundPosition: 'center top'
    }} aria-hidden="true" data-id="element-189" />

      {/* Overlay — heavier on mobile for text legibility, directional on desktop */}
      <div className="absolute inset-0 sm:hidden" style={{
      background: 'rgba(10,10,10,0.75)'
    }} aria-hidden="true" data-id="element-190" />
      <div className="absolute inset-0 hidden sm:block" style={{
      background: 'linear-gradient(105deg, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.85) 40%, rgba(10,10,10,0.3) 70%, rgba(10,10,10,0.15) 100%)'
    }} aria-hidden="true" data-id="element-191" />

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32" style={{
      background: 'linear-gradient(to bottom, transparent, #0a0a0a)'
    }} aria-hidden="true" data-id="element-192" />

      {/* Content — single version for all screen sizes */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 flex flex-col justify-center" style={{
      minHeight: '100vh',
      paddingTop: '80px',
      paddingBottom: '60px'
    }} data-id="element-193">
        <div ref={headlineRef} className="max-w-2xl" data-id="element-194">
          {/* Section label */}
          <div className="flex items-center gap-3 mb-6" data-id="element-195">
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-196" />
            <span className="section-label" data-id="element-197">
              By Guerra Barbershop · Hialeah, FL
            </span>
          </div>

          {/* Main headline */}
          <h1 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(2rem, 6vw, 4.5rem)',
          fontWeight: 900,
          lineHeight: 1.1,
          color: '#F5F5F5',
          marginBottom: '1.5rem'
        }} data-id="element-198">
            Walk In Looking Regular.{' '}
            <span style={{
            color: '#C9A84C',
            fontStyle: 'italic'
          }} data-id="element-199">
              Walk Out Looking Like Money.
            </span>
          </h1>

          {/* Sub-headline */}
          <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'clamp(0.95rem, 2vw, 1.2rem)',
          color: '#cccccc',
          lineHeight: 1.7,
          marginBottom: '2.5rem',
          maxWidth: '520px'
        }} data-id="element-200">
            The Hialeah Barbershop where every man gets the cut he actually
            asked for — no appointment needed.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-201">
            <a href="#location" className="btn-gold inline-flex items-center justify-center gap-3 px-8 py-4 text-base rounded-sm" data-id="element-202">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-203">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-204" />
                <circle cx="12" cy="10" r="3" data-id="element-205" />
              </svg>
              Walk In Today — Open Until 8PM
            </a>
            <a href="tel:7865364035" className="inline-flex items-center justify-center gap-3 px-8 py-4 text-base rounded-sm transition-all hover:opacity-80" style={{
            border: '1px solid rgba(201,168,76,0.5)',
            color: '#C9A84C',
            fontFamily: 'var(--font-callout)',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase'
          }} data-id="element-206">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-207">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-208" />
              </svg>
              (786) 536-4035
            </a>
          </div>

          {/* Trust signals */}
          <div className="flex flex-wrap items-center gap-6 mt-8" data-id="element-209">
            <div className="flex items-center gap-2" data-id="element-210">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#C9A84C" stroke="none" aria-hidden="true" data-id="element-211">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-212" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.85rem',
              color: '#888'
            }} data-id="element-213">
                Walk-ins Always Welcome
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-214">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-215">
                <circle cx="12" cy="12" r="10" data-id="element-216" />
                <polyline points="12 6 12 12 16 14" data-id="element-217" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.85rem',
              color: '#888'
            }} data-id="element-218">
                Open Until 8PM Daily
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-219">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-220">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-221" />
                <circle cx="9" cy="7" r="4" data-id="element-222" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-223" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-224" />
              </svg>
              <span style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.85rem',
              color: '#888'
            }} data-id="element-225">
                Kids Welcome
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce" aria-hidden="true" data-id="element-226">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-227">
          <polyline points="6 9 12 15 18 9" data-id="element-228" />
        </svg>
      </div>
    </section>;
}